import { useState } from "react";
import React from "react";
import { ComposedModal, Button, ModalBody, ModalHeader, Grid, Row, Column } from "carbon-components-react";
import {BenefitGroup} from "../../components/enums/benefit-group"

function DisabilityPlanDetails({benefitGroup}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-4 mb-2 -ml-6">
          <p className="text-2xl">Disability Plan Details</p>
        </ModalHeader>
        <ModalBody aria-label="Plan Details">
          <div className="-ml-10 px-4 sm:-ml-6 sm:mr-16">
          <div className="bg-gray-200 mb-4">
            <Grid>
              <Row className="pt-2">
                <Column className="font-bold text-red-600">Short-Term Disability</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Benefit</Column>
                <Column className="mt-2 mb-2">70% of Basic Annual Earnings to a maximum of {benefitGroup === BenefitGroup.Executive ? <>$3,333</> : <>$2,333</>} <span className="font-bold">per week</span></Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Benefit Begins</Column>
                <Column className="mt-2 mb-2">15th Day</Column>
              </Row>
            </Grid>
          </div>
          <div className="bg-gray-200 mb-4">
            <Grid>
              <Row className="pt-2">
                <Column className="font-bold text-red-600">Long-Term Disability</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Benefit</Column>
                <Column className="mt-2 mb-2">60% of Basic Annual Earnings to a maximum of {benefitGroup === BenefitGroup.Executive ? <>$18,000</> : <>$10,000</>} <span className="font-bold">per month</span></Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Benefit Begins</Column>
                <Column className="mt-2 mb-2">90 days after onset of disability</Column>
              </Row>
            </Grid>
          </div>
          </div>
          <div className="-ml-2">
            <div className="font-bold text-red-600">Important Information</div>
            <ul className="mx-8 mb-8 list-disc">
              <li>Not voluntary coverages</li>
              <li>Automatic enrollment</li>
            </ul>
          </div>
        </ModalBody>
      </ComposedModal>
      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default DisabilityPlanDetails;
